import {HERO_ROLES} from './cta.helper'
import {buttonFunctions} from 'hec/components/cta'
import {routeTypes} from 'hec/components/ui/button'

export const computeHeroPrimary = (goals = []) => {
    if (!Array.isArray(goals) || goals.length === 0) return HERO_ROLES.TAKE_QUIZ

    const norm = goals.map((g) => ({
        completed: !!(g?.completed ?? g?.complete),
        opened: !!(g?.openedAt ?? g?.open ?? g?.start)
    }))

    const areAllCompleted = norm.every((g) => g.completed)
    const areAllUnopened = norm.every((g) => !g.opened)
    if (areAllCompleted || areAllUnopened) return HERO_ROLES.TAKE_QUIZ
    const hasAnyOpened = norm.some((g) => g.opened)
    return hasAnyOpened ? HERO_ROLES.CONTINUE : HERO_ROLES.TAKE_QUIZ
}

export const getHeroOverrides = (role, lessonUrl, activeGoal, scrollTargetId) => {
    const GOAL_DASHBOARD_BASE = '/learning-center'
    const buildGoalDashboardUrl = (goalId) => `${GOAL_DASHBOARD_BASE}/${goalId}`
    const hasActiveGoal = Boolean(activeGoal)
    const hasActiveLesson = Boolean(lessonUrl)

    switch (role) {
        case HERO_ROLES.TAKE_QUIZ:
            return {
                clickFunction: buttonFunctions.linkToPage,
                routeType: routeTypes.INTERNAL,
                url: `${GOAL_DASHBOARD_BASE}/questionnaire`
            }

        case HERO_ROLES.CONTINUE: {
            if (hasActiveLesson) {
                return {
                    clickFunction: buttonFunctions.linkToPage,
                    routeType: routeTypes.INTERNAL,
                    url: lessonUrl
                }
            }
            if (hasActiveGoal && !hasActiveLesson) {
                return {
                    clickFunction: buttonFunctions.linkToPage,
                    routeType: routeTypes.INTERNAL,
                    url: buildGoalDashboardUrl(activeGoal)
                }
            }

            return {
                clickFunction: buttonFunctions.linkToPage,
                routeType: routeTypes.ELEMENT,
                url: `/${GOAL_DASHBOARD_BASE}#${scrollTargetId}`
            }
        }

        default:
            return null
    }
}
